import { ratingCategories } from '@/mocks/features';

export default function ReviewSection() {
  return (
    <section id="review" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
              Review
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              Sugargoo Review 2026: <span className="text-primary-500">Is Sugargoo Worth Using?</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              After extensive testing and analysis, we have evaluated Sugargoo across multiple categories that matter most to international shoppers. Here is our honest, independent assessment of the platform&apos;s performance in 2026.
            </p>

            <div className="space-y-3">
              {ratingCategories.map((item) => (
                <div key={item.category} className="flex items-center justify-between py-2.5 px-4 bg-background-100 rounded-lg">
                  <span className="text-sm font-medium text-foreground-800">{item.category}</span>
                  <div className="flex items-center gap-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < item.score ? 'text-primary-400 ri-star-fill' : 'text-background-300 ri-star-line'}`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-xs font-semibold text-accent-600 min-w-[60px] text-right">{item.rating}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Visit Main Platform
              </a>
              <a
                href="/article/sugargoo-review-2026"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-700 border border-background-200/70 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-article-line"></i>
                Read Full Review
              </a>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="w-full h-72 md:h-80 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20sleek%20modern%20review%20and%20rating%20concept%20with%20five%20star%20ratings%20glowing%20on%20a%20dark%20minimal%20tablet%20screen%2C%20surrounded%20by%20small%20decorative%20objects%20on%20a%20light%20wooden%20desk%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20window%20light%2C%20editorial%20photography%2C%20professional%20trustworthy%20atmosphere&width=800&height=600&seq=review-main-v3&orientation=landscape"
                alt="Sugargoo Review 2026 - Platform ratings and evaluation analysis"
                title="Sugargoo 2026 Review and Rating Analysis"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}